import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme: any) => ({
  mainLayoutContainer: {
    backgroundColor: "#f8f8f8",
    display: "block",
  },
  card: {
    paddingBottom: "200px",
    marginTop: "50px",
    [theme.breakpoints.down("575")]: {
      paddingBottom: "100px",
    },
    [theme.breakpoints.down("430")]: {
      marginTop: "10px",
    },
  },
  paperMinHeight: {
    minHeight: "500px",
  },
  paper: {
    padding: "90px 60px",
    boxShadow: "0px 0px 80px rgba(0, 0, 0, 0.1) !important",
    borderRadius: "10px",
    // minHeight: "auto",
    height: "100%",
    [theme.breakpoints.down("991")]: {
      padding: "75px 40px",
    },
    [theme.breakpoints.down("767")]: {
      padding: "60px 30px",
    },
    [theme.breakpoints.down("575")]: {
      padding: "40px 10px",
      boxShadow: "unset!important",
    },
    [theme.breakpoints.down("430")]: {
      padding: "20px 0px",
    },
  },
  container: {
    [theme.breakpoints.down("575")]: {
      "&.MuiContainer-root": {
        paddingLeft: 10,
        paddingRight: 10,
      },
    },
  },
}));

export default useStyles;
